export const Employment = [
    {
        startDate: "August 2023",
        endDate: "Present",
        company: "Elexity",
        position: "UI/UX Designer and Developer",
        details: {
            se_0: "Collaborated with the executive and backend engineering teams to design and develop a new web platform using React.js and Figma. Crafted and continuously improved the user journey and experience based on data collection.",
            se_1: "Assumed leadership in reimagining, redesigning, and enhancing the user journey and experience across the web platform.",
            se_2: "Spearheaded the development of the front end of the web platform, enabling the seamless display and generation of complex, real-time data for more than 15 accounts via APIs.",
            se_3: "Orchestrated user surveys to gather invaluable insights, driving informed decisions for future design enhancements and feature integrations.",
            se_4: "Directed the overhaul of over 10 existing React components, applying modern practices such as the utilization of React hooks to optimize functionality and maintainability.",
        },
    },

    {
        startDate: "August 2022",
        endDate: "June 2023",
        company: "BombBomb",
        position: "Software Engineer",
        details: {
            se_0: "Successfully implemented and maintained 12-15 features per quarter utilizing React.js, PHP, and SQL, resulting in continuous enhancement of product functionality.",
            se_1: "Actively contributed to backlog by creating tickets for identifying and addressing bugs or enhancements in the codebase.",
            se_2: "Took ownership of trial sign-up and on-boarding experiences, leading research spikes, conducting 4+ A/B experiments, implementing metric logging, and effectively managing them within the codebase.",
            se_3: "Executed growth experiments on the trial sign-up form, resulting in a significant 2.5% increase in new trial sign-ups.",
            se_4: "Ensured consistency and scalability by proficiently managing and updating various React components within the internal design system.",
        },
    },

    {
        startDate: "December 2020",
        endDate: "August 2022",
        company: "BombBomb",
        position: "Junior Software Engineer",
        details: {
            jse_0: "Improved web application user experiences using React.js and PHP to drive acquisition and activation growth. Developed new features while iterating on existing ones, focusing on a user-centered approach.",
            jse_1: "Optimized user experience on-boarding process for several cohorts based on professional industry, resulting in a 2% increase in trial-to-paid conversion rate.",
            jse_2: "Collaborated with 2-3 cross-functional teams to successfully implement and maintain experiments.",
            jse_3: "Participated in the company's hack week that resulted in the team's redesigned dashboard and on- boarding checklist feature becoming part of the in-app experience.",
            jse_4: "Streamlined lead generation by integrating third-party software, collaborating across 3 teams to collect and validate qualified lead data accurately.",
        },
    },

    {
        startDate: "July 2019",
        endDate: "December 2020",
        company: "BombBomb",
        position: "Front End Developer",
        details: {
            fed_0: "Revamped and managed website, blog, and event pages using expertise in HTML/HTML5, CSS/SCSS, Vanilla JavaScript, jQuery, and WordPress, resulting in a total of over 100 pages.",
            fed_1: "Applied seamless functionality and user-friendly design to enhance the overall user experience.",
            fed_2: "Enhanced the web speed and web performance of the marketing website by approximately 20%, ensuring compatibility across various browsers and devices.",
            fed_3: "Evolved 4-8 website elements such as the navigation bar and testimonial slider to be responsive, mobile-friendly, and reduced lines of code and tech debt.",
            fed_4: "Proposed the integration of agile methodology into the team's workflow, advocating for its adoption and emphasizing its value in enhancing productivity and delivering successful outcomes.",
        },
    },
]

export const Skills = [
    {
        title: "Languages",
        list: "JavaScript, TypeScript, HTML/HTML5, SCSS/CSS, PHP"
    },

    {
        title: "Libraries and Frameworks",
        list: "React.js, Node.js, jQuery"
    },

    {
        title: "Other",
        list: "Docker, Firebase, Github, Postgres, Postman, Regex, SQL, Figma, Storybook, Agile/Scrum Development, UI/UX Design, A/B Testing, Responsive Web Design" 
    }
]